import { put, takeLatest } from "redux-saga/effects";
import {
  fetchDomainsRequest,
  fetchDomainsSuccess,
  fetchDomainsFailure,
} from "./domainSlice";
import { fastApiURL } from "../../utils/config";

function* fetchDomainsSaga() {
  try {
    const response = yield fetch(`${fastApiURL}/api/domains`);

    if (!response.ok) {
      throw new Error(`Failed to fetch Domains: ${response.status}`);
    }

    const data = yield response.json();

    const domains = data.map((domain) => ({
      id: domain.id,
      name: domain.name,
      color: domain.color,
    }));

    yield put(fetchDomainsSuccess(domains));
  } catch (error) {
    console.error("Error in fetchDomainsSaga:", error);
    yield put(fetchDomainsFailure(error.message));
  }
}

export function* watchDomainsSaga() {
  yield takeLatest(fetchDomainsRequest.type, fetchDomainsSaga);
}